import { CustomerInfo } from '@/domain/CustomerInfo'
import { UserInfo } from '@/domain/UserInfo'
import { Invoice, InvoiceDetail } from '@/domain/Invoice'
import FileData from '@/domain/FileData'
import DateUtils from '@/utils/DateUtils'

/**
 * 代理店請求
 */
export class AgencyInvoice {
    /** 代理店請求番号 */
    agencyInvoiceNo = ""
    /** 代理店請求日 YYYY-MM-DD */
    agencyInvoiceOn = ""
    /** 合算開始日 YYYY-MM-DD */
    startOn = ""
    /** 合算終了日 YYYY-MM-DD */
    endOn = ""
    /** 作成者 */
    authorUser = new UserInfo()
    /** 承認者 */
    authorizerUser = new UserInfo()
    /** 代理店情報 */
    agencyInfo = new CustomerInfo()
    /** 小計 */
    amount = 0
    /** 消費税 */
    tax = 0
    /** 手数料 */
    fee = 0
    /** メール送信日時 */
    mailSendAt: string | null = null
    /** 印刷日時 */
    printAt: string | null = null

    /* 代理店請求対象 */
    invoices: Invoice[] = []

    /* 合算請求対象明細 */
    details: InvoiceDetail[] = []

    /** 代理店請求書 */
    agencyInvoiceFile: FileData = new FileData()

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<AgencyInvoice>) {
        Object.assign(this, init)
    }

    /**
     * 複製を作成する
     */
    clone() {
        return new AgencyInvoice(JSON.parse(JSON.stringify(this)));
    }

    /**
     * 明細を集計する
     */
    sum() {
        if (this.invoices.length === 0) {
            this.amount = 0
            this.tax = 0
            this.fee = 0
        }
        this.amount = this.invoices
            .map(x => x.sumInfo.amount)
            .reduce((p, x) => p + x, 0)
        this.tax = this.invoices
            .map(x => x.sumInfo.tax)
            .reduce((p, x) => p + x, 0)
        this.fee = this.invoices
            .map(x => x.sumInfo.fee)
            .reduce((p, x) => p + x, 0)
    }

    /**
     * メール送信済みか？
     */
    get isMailSended() {
        return !(this.mailSendAt === null || this.mailSendAt === "")
    }

    /**
     * 印刷済みか？
     */
    get isPrinted() {
        return !(this.printAt === null || this.printAt === "")
    }

    /**
     * ロック状態(編集不可)か？
     */
    get isLocked() {
        return false
    }

    /**
     * 小計（カンマ区切り）
     */
    get amountText() {
        return isNaN(this.amount) ? "-" : this.amount.toLocaleString()
    }

    /**
     * 消費税（カンマ区切り）
     */
    get taxText() {
        return isNaN(this.tax) ? "-" : this.tax.toLocaleString()
    }

    /**
     * 合計金額
     */
    get totalAmount() {
        return this.amount + this.tax
    }

    /**
     * 合計金額（カンマ区切り）
     */
    get totalAmountText() {
        return isNaN(this.totalAmount) ? "-" : this.totalAmount.toLocaleString()
    }

    /**
     * フィルターキーワードの取得
     */
    get filterKeyword() {
        const dateUtils = DateUtils.instance
        return `${dateUtils.toJapanFormat(this.agencyInvoiceOn)} ${this.agencyInvoiceNo} ${this.agencyInfo.customerName}`
    }
}

/**
 * サマリ情報
 */
export class SummaryInfo {
    /** 顧客名 */
    customerName = ""
    /** 金額 */
    amount = 0

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<SummaryInfo>) {
        Object.assign(this, init)
    }
}
